import { render } from "./Slack2.vue?vue&type=template&id=abe20db4"
import script from "./Slack2.vue?vue&type=script&lang=js"
export * from "./Slack2.vue?vue&type=script&lang=js"
script.render = render

export default script